import { Trans } from '@lingui/macro'
import React, { FC } from 'react'

export const AnswerValidation = ({ children }) => {
  return <div className="QuizElement__answer__note">{children}</div>
}

export const FreeQuizNote: FC<{
  currentLength: number
  minLength: number
  maxLength: number
}> = ({ currentLength, minLength, maxLength }) => {
  // do not remove spans here-when removed, google translate breaks react DOM diffing-see https://github.com/facebook/react/issues/11538#issuecomment-390386520
  if (currentLength < minLength) {
    return (
      <AnswerValidation>
        <span>
          <Trans>Minimum answer length is {minLength} characters.</Trans>
        </span>
      </AnswerValidation>
    )
  } else if (currentLength > maxLength) {
    return (
      <AnswerValidation>
        <span>
          <Trans>Your answer is too long</Trans>
        </span>
      </AnswerValidation>
    )
  }

  return <AnswerValidation>&nbsp;</AnswerValidation>
}
